import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { SubscriptionPlans } from './SubscriptionPlans';
import { TokenPlans } from './TokenPlans';
import { ContactForm } from './ContactForm';
import { SUBSCRIPTION_PLANS } from '../../utils/constants/subscriptionPlans';

export const SubscriptionPlansPage = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showTokenPlans, setShowTokenPlans] = useState(false);
  const [showContactForm, setShowContactForm] = useState(false);

  const handleSelectPlan = (plan) => {
    if (plan.id === 'pay-as-you-go') {
      setShowTokenPlans(true);
    } else if (plan.id === 'enterprise') {
      setShowContactForm(true);
    } else {
      // Navigate to signup with plan
      const signupPath = `/signup/${plan.id.toLowerCase()}`;
      console.log('Navigating to:', signupPath);
      navigate(signupPath, { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-[#3D3F42] flex flex-col">
      {/* Header */}
      <div className="sticky top-0 bg-[#2A2B2E] shadow-sm z-10 p-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/login')}
            className="p-2 hover:bg-gray-700 rounded-lg"
          >
            <ArrowLeft className="w-6 h-6 text-white" />
          </button>
          <div>
            <h1 className="text-xl font-semibold text-white">Choose Your Plan</h1>
            <p className="text-sm text-gray-400">Start with a 14-day free trial</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-4">
        <div className="max-w-4xl mx-auto">
          {/* Plans */}
          {showTokenPlans ? (
            <TokenPlans onBack={() => setShowTokenPlans(false)} />
          ) : showContactForm ? (
            <ContactForm onBack={() => setShowContactForm(false)} />
          ) : (
            <SubscriptionPlans onSelectPlan={handleSelectPlan} />
          )}

          {/* Features Comparison */}
          <div className="mt-8 bg-[#2A2B2E] rounded-lg p-6">
            <h2 className="text-lg font-medium text-white mb-4">All Plans Include</h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <p className="text-gray-300">• Full route planning capabilities</p>
                <p className="text-gray-300">• Real-time weather and road conditions</p>
                <p className="text-gray-300">• Unlimited POI management</p>
                <p className="text-gray-300">• Export and sharing features</p>
              </div>
              <div className="space-y-2">
                <p className="text-gray-300">• Team collaboration tools</p>
                <p className="text-gray-300">• Mobile app access</p>
                <p className="text-gray-300">• Regular feature updates</p>
                <p className="text-gray-300">• Priority support</p>
              </div>
            </div>
          </div>

          {/* Back to Login */}
          <div className="mt-8 text-center">
            <p className="text-gray-400 mb-4">
              Already a member?{' '}
              <button 
                onClick={() => navigate('/login')}
                className="text-red-400 hover:text-red-300"
              >
                Sign in
              </button>
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#2A2B2E] p-3 text-center text-gray-400 text-xs">
        Powered by Soltec - Version 6.0
      </div>
    </div>
  );
};